<script lang="ts">
	import shelfImageXs from "@assets/images/shelf.jpg?webp&h=640&imagetools";
	import shelfImageSm from "@assets/images/shelf.jpg?webp&h=900&imagetools";
	import shelfImageLg from "@assets/images/shelf.jpg?webp&w=1280&imagetools";
	import shelfImageXl from "@assets/images/shelf.jpg?webp&w=1536&imagetools";
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import AboutUsContentSection from "@components/sections/AboutUsContentSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./MembershipAboutSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<AboutUsContentSection heading={translate("sectionTitle")}>
	{#snippet media()}
		<Media
			sourcesets={{
				">lg": shelfImageLg,
				">sm": shelfImageSm,
				">xl": shelfImageXl,
			}}
			source={{ src: shelfImageXs, type: "image/webp" }}
			alt={translate("shelfImageAlt")}
			width={288}
			height={432}
			class="object-cover w-auto h-108 lg:h-144"
		/>
	{/snippet}
	<Formatted text={translate("sectionParagraph")} />
</AboutUsContentSection>
